import React from 'react';

function SenderField({ data, value, maxLength }) {
  if (!value) return <>-</>;

  if (data.sender == null || data.sender == undefined) {
    return <>Extra</>;
  }

  if (maxLength && typeof value === 'string' && value.length > maxLength) {
    return <>{value.substr(0, maxLength)}...</>;
  }

  return <>{value}</>;
}

export default SenderField;
